/**
 * Image helpers, CDN resizing, and SEO-optimized descriptive alt texts
 * for Cryo by Breum.
 */

const CDN_PREFIX = 'https://assets.auxodev.dk/assets/bbc8c269-a12e-46e2-947b-0cefa0025eea/';

export const ASSET_URLS = {
  logo: `${CDN_PREFIX}cryo-by-breum-logo.png`,
  reception: `${CDN_PREFIX}cryo-by-breum-reception-og-ventevaerelse.jpg`,
  emsStudio: `${CDN_PREFIX}cryo-by-breum-ems-studio-behandlingsrum.jpg`,
  treatmentRoom: `${CDN_PREFIX}cryo-by-breum-klinik-behandlingsrum-briks.jpg`,
  fedtfrysning: `${CDN_PREFIX}cryo-by-breum-fedtfrysning-behandling-applikatorer.jpg`,
  bodyRoll: `${CDN_PREFIX}cryo-by-breum-body-roll-massage-maskine.jpg`,
  cryoMan: `${CDN_PREFIX}cryo-by-breum-kryosauna-behandling-mand.jpg`,
  cryoWoman: `${CDN_PREFIX}cryo-by-breum-kryosauna-behandling-kvinde.jpg`,
  cryoDamp: `${CDN_PREFIX}cryo-by-breum-kryoterapi-kabine-damp.jpg`,
};

/**
 * Detailed, SEO-optimized Danish alt texts for all clinic imagery
 */
export const IMAGE_ALT_TEXTS = {
  'cryo-by-breum-logo': 'CRYO BY BREUM logo - Klinik for fedtfrysning, EMS træning og Body Roll i Odense',
  'cryo-by-breum-reception-og-ventevaerelse': 'Lyst receptionsområde og venteværelse med sildebensparket og lædersofa hos Cryo by Breum på Dalumvej i Odense',
  'cryo-by-breum-ems-studio-behandlingsrum': 'Privat EMS træningsstudio og behandlingsrum med behandlerbriks og trælameller hos Cryo by Breum',
  'cryo-by-breum-klinik-behandlingsrum-briks': 'Roligt og lyst behandlingsrum med hvid behandlerbriks og professionelt apparatur hos Cryo by Breum',
  'cryo-by-breum-fedtfrysning-behandling-applikatorer': 'Fedtfrysning behandling med professionelle applikatorer og beskyttende gelmembran hos Cryo by Breum i Odense',
  'cryo-by-breum-body-roll-massage-maskine': 'Sort Body Roll rullemaskine til kropsmassage og lymfedrænage i behandlingsrum hos Cryo by Breum',
  'cryo-by-breum-kryosauna-behandling-mand': 'Mand under helkrops kryosauna kuldebehandling med kold damp hos Cryo by Breum',
  'cryo-by-breum-kryosauna-behandling-kvinde': 'Kvinde under opkvikkende kryoterapibehandling i gylden kryokabine hos Cryo by Breum',
  'cryo-by-breum-kryoterapi-kabine-damp': 'Kvinde i badekåbe træder ud af gylden kryoterapikabine med kold damp hos Cryo by Breum',
};

/**
 * Returns a precise, descriptive Danish alt text for any image URL or filename
 */
export function getImageAlt(imageUrl, fallbackContext = '') {
  if (!imageUrl || typeof imageUrl !== 'string') {
    return fallbackContext || 'Cryo by Breum klinikbillede';
  }

  for (const [key, altText] of Object.entries(IMAGE_ALT_TEXTS)) {
    if (imageUrl.includes(key)) {
      return altText;
    }
  }

  if (fallbackContext) {
    return `${fallbackContext} - Cryo by Breum i Odense`;
  }

  return 'Cryo by Breum - Klinik for kropsbehandlinger og træning i Odense';
}
